import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import URLS from "redux/urls";
import request from "redux/utils/request";

export const fetchAllDashboard = createAsyncThunk(
  "Dashboard/fetchAllDashboard",
  async (params, { rejectWithValue }) => {
    try {
      const response = await request("get", URLS.DASHBOARD, params);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addDashboard = createAsyncThunk(
  "Dashboard/addDashboard",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await request("post", URLS.DASHBOARD, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateDashboard = createAsyncThunk(
  "Dashboard/updateDashboard",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await request(
        "patch",
        `${URLS.DASHBOARD}/${payload.id}`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const fetchOneDashboard = createAsyncThunk(
  "Dashboard/fetchOneDashboard",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("get", `${URLS.DASHBOARD}/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteDashboard = createAsyncThunk(
  "Dashboard/deleteDashboard",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("delete", `${URLS.DASHBOARD}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  loading: {
    query: false,
    mutation: false,
  },
  filter: {
    q: "",
  },
  list: [],
  count: {},
  selected: {},
  selectedRows: [],
};

const loadingReducer = (fieldName, status) => (state) => {
  state.loading[fieldName] = status;
};

const startLoadingQuery = loadingReducer("query", true);
const stopLoadingQuery = loadingReducer("query", false);
const startLoadingMutation = loadingReducer("mutation", true);
const stopLoadingMutation = loadingReducer("mutation", false);

export const DashboardSlice = createSlice({
  name: "Dashboard",
  initialState,
  reducers: {
    setAppliedSearchText: (state, action) => {
      state.filter.q = action.payload;
    },
    setSelectedRows: (state, action) => {
      state.selectedRows = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllDashboard.pending, startLoadingQuery)
      .addCase(fetchAllDashboard.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading.query = false;
      })
      .addCase(fetchAllDashboard.rejected, stopLoadingQuery);
    builder
      .addCase(fetchOneDashboard.pending, startLoadingQuery)
      .addCase(fetchOneDashboard.rejected, stopLoadingQuery)
      .addCase(fetchOneDashboard.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(updateDashboard.pending, startLoadingQuery)
      .addCase(updateDashboard.rejected, stopLoadingQuery)
      .addCase(updateDashboard.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(deleteDashboard.pending, startLoadingMutation)
      .addCase(deleteDashboard.fulfilled, stopLoadingMutation)
      .addCase(deleteDashboard.rejected, stopLoadingMutation);
  },
});

export const { setSelectedRows, setAppliedSearchText } = DashboardSlice.actions;

export default DashboardSlice.reducer;
